import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import config from '../config.json';

export default class Firebase {
    public auth: app.auth.Auth;
    public db: app.firestore.Firestore;

    public constructor() {
        app.initializeApp(config.firebase);
        this.auth = app.auth();
        this.db = app.firestore();
    }
}



// WEBPACK FOOTER //
// ./src/Firebase/firebase.ts